interface MultiStringText {
  text1: string
  focusText: string
  text2: string
}

interface Props {
  isLoading: boolean
  text: string | MultiStringText
  textType: 'string' | 'multi-string'
}

export default function SubmitButton({ isLoading, text, textType }: Props) {
  const renderText = () => {
    if (textType === 'multi-string' && typeof text !== 'string') {
      return (
        <>
          {text.text1}{' '}
          <span className="text-[#0CDFBF]">
            {text.focusText}
          </span>{' '}
          {text.text2}
        </>
      )
    }

    return <>{text}</>
  }

  return (
    <button
      type="submit"
      disabled={isLoading}
      className="w-full mt-4 flex items-center justify-center gap-2 bg-primary-500 text-white py-[.85rem] text-[16px] rounded-md
        transition ease-in-out duration-200 disabled:cursor-not-allowed
        disabled:opacity-75 font-semibold hover:bg-primary-700
        focus:ring-primary-100 focus:ring-4 px-2"
      id="login-submit-button"
    >
      {isLoading ? (
        <>
          <span>{renderText()}</span>
          <svg
            className="animate-spin h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 
                5.291A7.962 7.962 0 014 12H0c0 
                3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </>
      ) : (
        <span>{renderText()}</span>
      )}
    </button>
  )
}
